import { render, staticRenderFns } from "./QuickCreate.vue?vue&type=template&id=1d6e73da&scoped=true&"
import script from "./QuickCreate.vue?vue&type=script&lang=js&"
export * from "./QuickCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuickCreate.vue?vue&type=style&index=0&id=1d6e73da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e73da",
  null
  
)

component.options.__file = "QuickCreate.vue"
export default component.exports